import { apiClient } from '@/lib/api-client';

// ─── Types ──────────────────────────────────────────────────────────────────

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: string;
  tenant_id: string;
}

export interface AuthResponse {
  user: AuthUser;
  access_token?: string;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  role: string;
  tenant_id: string;
  tenant?: {
    id: string;
    business_name: string;
    business_type: string;
  };
  locations?: { id: string; name: string; is_active: boolean }[];
}

// ─── Service ────────────────────────────────────────────────────────────────

export const authService = {
  requestOtp(email: string) {
    return apiClient<{ message: string }>('/auth/otp', {
      method: 'POST',
      body: { email },
      skipAuth: true,
    });
  },

  verifyOtp(email: string, otp: string) {
    return apiClient<AuthResponse>('/auth/verify', {
      method: 'POST',
      body: { email, otp },
      skipAuth: true,
    });
  },

  login(email: string, password: string) {
    return apiClient<AuthResponse>('/auth/login', {
      method: 'POST',
      body: { email, password },
      skipAuth: true,
    });
  },

  refreshSession() {
    return apiClient<AuthResponse>('/auth/refresh', {
      method: 'POST',
      skipAuth: true,
    });
  },

  getMe() {
    return apiClient<UserProfile>('/auth/me');
  },

  logout() {
    return apiClient<{ message: string }>('/auth/logout', {
      method: 'POST',
    });
  },
};
